import type * as React from 'react';
import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import type { ChatInputTokenProps, ChatInputTokenState } from './ChatInputToken.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render ChatInputToken.
 *
 * The returned state can be modified with hooks such as useChatInputTokenStyles_unstable,
 * before being passed to renderChatInputToken_unstable.
 *
 * @param props - props from this instance of ChatInputToken
 * @param ref - reference to root HTMLElement of ChatInputToken
 */
export const useChatInputToken_unstable = (
  props: ChatInputTokenProps,
  ref: React.Ref<HTMLElement>,
): ChatInputTokenState => {
  return {
    components: {
      root: 'span',
    },
    root: slot.always(
      getIntrinsicElementProps('span', {
        ref,
        ...props,
      }),
      { elementType: 'span' },
    ),
  };
};
